import { Card, Col, Row, Typography } from "antd";
import { StyleSheet } from "../StyleSheet";
const { Text } = Typography;

interface InfoCardProps {
    paymentsPesos: string;
    paymentsCentavo: number;
}

const PaymentAmount = (props: InfoCardProps) => {
    const { paymentsPesos, paymentsCentavo } = props;

    return (
        <Card style={styles.rowRoot} styles={{ body: { paddingTop: 15 } }} >
            <Row align={"middle"} justify={"space-between"} >
                <Col sm={24} md={15}>
                    <Text style={styles.textTitle}>{"Saldo a Pagar:"}</Text>
                </Col>
                <Col sm={24} md={9}>
                    <div style={styles.rowView}>
                        <Text
                            style={styles.textPaymentAmount}>
                            {"$" + paymentsPesos}.
                        </Text>
                        <Text
                            style={styles.textPaymentCents}>
                            {paymentsCentavo > 0 ? paymentsCentavo : paymentsCentavo + '0'}
                        </Text>
                    </div>
                </Col>
            </Row>
        </Card>
    );
};

const styles = StyleSheet.create({
    rowRoot: {
        backgroundColor: "#0055c2",
        paddingTop: 0,
        borderRadius: 15,
        boxShadow: "0px 0px 8px #00000029",
        height: 80,
    },
    textTitle: {
        fontSize: 18,
        color: "white",
        fontWeight: 'normal',
    },
    textDescription: {
        color: "white",
    },
    colView: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 20
    },
    rowView: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'flex-end'
    },
    textPaymentAmount: {
        color: "#ffffff",
        fontSize: 30,
        fontWeight: 'bold',
    },
    textPaymentCents: {
        color: "#ffffff",
        fontSize: 18,
        paddingTop: 2,
        fontWeight: 'bold',
    },
});

export default PaymentAmount;
